function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import FormGroup from "./FormGroup";
import Label from "./Label";
import Input from "./Input";

var CheckboxGroup = function CheckboxGroup(_ref) {
  var options = _ref.options,
      selected = _ref.selected,
      onChange = _ref.onChange;

  var _useState = useState(uuidv4()),
      _useState2 = _slicedToArray(_useState, 1),
      groupId = _useState2[0];

  var handleCheckboxChange = function handleCheckboxChange(checked, value) {
    var newSelected = new Set(selected);

    if (checked) {
      newSelected.add(value);
    } else {
      newSelected.delete(value);
    }

    onChange(Array.from(newSelected));
  };

  return /*#__PURE__*/React.createElement(FormGroup, null, options.map(function (option) {
    var id = "option-".concat(option.label, "-").concat(groupId);
    return /*#__PURE__*/React.createElement(FormGroup, {
      check: true,
      key: option.value,
      className: "py-1 d-flex align-items-center"
    }, /*#__PURE__*/React.createElement(Input, {
      type: "checkbox",
      checked: selected.includes(option.value),
      onChange: function onChange(ev) {
        return handleCheckboxChange(ev.target.checked, option.value);
      },
      className: "my-0",
      id: id
    }), /*#__PURE__*/React.createElement(Label, {
      check: true,
      className: "my-0",
      for: id
    }, ' ', option.label));
  }));
};

CheckboxGroup.displayName = "CheckboxGroup";
CheckboxGroup.displayName = 'CheckboxGroup';
export default CheckboxGroup;